import type { GameTypeCode } from "@monekineko/game-engine";
import { createBinaryLock } from "./binary-lock.js";
import { createCircuitPuzzle } from "./circuit-puzzle.js";
import { createCodeLine } from "./code-line.js";
import { createRobotRepair } from "./robot-repair.js";
import type { EngineFactory } from "./types.js";

// Визуальная половина реестра типов игр: код типа → механика на экране.
// Логическая половина живёт в @monekineko/game-engine и работает на сервере.

const ENGINES: Record<GameTypeCode, EngineFactory> = {
  binary_lock: createBinaryLock,
  robot_repair: createRobotRepair,
  circuit_puzzle: createCircuitPuzzle,
  code_line: createCodeLine,
};

export function getEngine(code: string): EngineFactory | null {
  return ENGINES[code as GameTypeCode] ?? null;
}
